import { fetcher } from '@commenda/utils';

export interface UnlinkAdminSlackChannelParams {
  companyId: number;
}

export interface UnlinkAdminSlackChannelResponse {
  success: boolean;
}

export async function unlinkAdminSlackChannel({
  companyId,
}: UnlinkAdminSlackChannelParams): Promise<UnlinkAdminSlackChannelResponse> {
  const response = await fetcher(
    `admin/companies/${companyId}/external-connections/slack`,
    { method: 'DELETE' }
  );

  if (!response.ok) {
    const body = (await response.json().catch(() => null)) as {
      message?: unknown;
      error?: unknown;
    } | null;
    const message =
      typeof body?.message === 'string'
        ? body.message
        : Array.isArray(body?.message)
          ? body.message.join(', ')
          : typeof body?.error === 'string'
            ? body.error
            : 'Failed to unlink Slack channel';
    throw new Error(message);
  }

  return response.json();
}
